module.exports = __webpack_public_path__ + "img/组织-动画.469def31.png";